/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPASSETTYPE } from './IAPASSETTYPE';
import {
    IAPASSETTYPEFromJSON,
    IAPASSETTYPEFromJSONTyped,
    IAPASSETTYPEToJSON,
} from './IAPASSETTYPE';
import type { IAPSWITCHINTYPE } from './IAPSWITCHINTYPE';
import {
    IAPSWITCHINTYPEFromJSON,
    IAPSWITCHINTYPEFromJSONTyped,
    IAPSWITCHINTYPEToJSON,
} from './IAPSWITCHINTYPE';

/**
 * 
 * @export
 * @interface InvestmentDetailsPhaseInToFundViewModel
 */
export interface InvestmentDetailsPhaseInToFundViewModel {
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsPhaseInToFundViewModel
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsPhaseInToFundViewModel
     */
    assetCode: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsPhaseInToFundViewModel
     */
    switchValue?: number;
    /**
     * 
     * @type {IAPASSETTYPE}
     * @memberof InvestmentDetailsPhaseInToFundViewModel
     */
    assetTypeId?: IAPASSETTYPE;
    /**
     * 
     * @type {IAPSWITCHINTYPE}
     * @memberof InvestmentDetailsPhaseInToFundViewModel
     */
    switchInTypeId?: IAPSWITCHINTYPE;
}

/**
 * Check if a given object implements the InvestmentDetailsPhaseInToFundViewModel interface.
 */
export function instanceOfInvestmentDetailsPhaseInToFundViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "assetCode" in value;

    return isInstance;
}

export function InvestmentDetailsPhaseInToFundViewModelFromJSON(json: any): InvestmentDetailsPhaseInToFundViewModel {
    return InvestmentDetailsPhaseInToFundViewModelFromJSONTyped(json, false);
}

export function InvestmentDetailsPhaseInToFundViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentDetailsPhaseInToFundViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'assetCode': json['AssetCode'],
        'switchValue': !exists(json, 'SwitchValue') ? undefined : json['SwitchValue'],
        'assetTypeId': !exists(json, 'AssetTypeId') ? undefined : IAPASSETTYPEFromJSON(json['AssetTypeId']),
        'switchInTypeId': !exists(json, 'SwitchInTypeId') ? undefined : IAPSWITCHINTYPEFromJSON(json['SwitchInTypeId']),
    };
}

export function InvestmentDetailsPhaseInToFundViewModelToJSON(value?: InvestmentDetailsPhaseInToFundViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'AssetCode': value.assetCode,
        'SwitchValue': value.switchValue,
        'AssetTypeId': IAPASSETTYPEToJSON(value.assetTypeId),
        'SwitchInTypeId': IAPSWITCHINTYPEToJSON(value.switchInTypeId),
    };
}

